import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({

  selectTypeTitle: {
    id: 'authoring.problemEditor.selectType.title',
    defaultMessage: 'Select problem type',
    description: 'Title for select problem type modal',
  },
  cancelButtonLabel: {
    id: 'authoring.problemeditor.selecttype.cancelButton.label',
    defaultMessage: 'Cancel',
    description: 'Label for cancel button.',
  },
  cancelButtonAriaLabel: {
    id: 'authoring.problemeditor.selecttype.cancelButton.ariaLabel',
    defaultMessage: 'Cancel',
    description: 'Screen reader label for cancel button.',
  },
  selectButtonLabel: {
    id: 'authoring.problemeditor.selecttype.selectButton.label',
    defaultMessage: 'Select',
    description: 'Label for select button.',
  },
  selectButtonAriaLabel: {
    id: 'authoring.problemeditor.selecttype.selectButton.ariaLabel',
    defaultMessage: 'Select',
    description: 'Screen reader label for select button.',
  },
});

export default messages;
